import React from 'react';
import { strings } from '../../../resources/strings';
import ServicesContext from '../../../contexts/ServicesContext';
import { ActionsBox } from '../../../common-components/Layout/ActionsBox/ActionsBox';
import { Field, FieldType } from '../../../common-components/Field/Field';
import { Container, ContainerBody, ContainerFooter, ContainerHeader, HeaderTitle } from './styles';

export interface IAssemblerNoteFormProps {
  save?: (note: string) => void;
  cancel?: () => void;
}

const formActions = {
  Cancel: 'cancel',
  Save : 'save'
}

export const AssemblerNoteForm: React.FC<IAssemblerNoteFormProps> = ({
  save,
  cancel
}) => {

  const [note, setNote] = React.useState<string>('');

  const { alertService } = React.useContext(ServicesContext);

  return (
    <Container>
      <ContainerHeader>
        <HeaderTitle>Informe a observação e acione a opção Salvar.</HeaderTitle>
      </ContainerHeader>
      <ContainerBody>
        <Field
          type={FieldType.TextArea}
          value={note}
          change={(value) => setNote(value)}
          marginTop='0px'
          autoFocus
        />
      </ContainerBody>
      <ContainerFooter>
        <ActionsBox
          actions={[
            { key: formActions.Cancel, text: strings.Cancel },
            { key: formActions.Save, text: strings.Save }
          ]}
          defaultItemWidth='90px'
          click={actionsBoxClick}
        />
      </ContainerFooter>
    </Container>
  );

  function actionsBoxClick(key: string) {
    if (key === formActions.Cancel && cancel) {
      cancel();
      return;
    }

    if (key === formActions.Save && save) {
      if (!note) {
        alertService.warning(`Nenhuma observação informada!`);
        return;
      }
      save(note);
      return;
    }
  }

}